<template>
  <div class="siimple-table-row">
    <div class="siimple-table-cell">
      <emoji
        v-for="(emoji, index) in emojisArray"
        :key="index"
        :value="emoji"
      />
    </div>
    <div class="answer siimple-table-cell">
      <div class="correct siimple-input siimple-input--fluid">
        {{ item.solutions[0] }}
      </div>
    </div>
  </div>
</template>

<script>
import Emoji from '@/components/Emoji';
import GraphemeSplitter from 'grapheme-splitter';

const splitter = new GraphemeSplitter();

export default {
  name: 'SolutionItem',
  components: {
    Emoji
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    emojisArray() {
      return splitter.splitGraphemes(this.item.text);
    }
  }
};
</script>

<style scoped>
.siimple-input.correct {
  color: black;
  text-transform: capitalize;
}

.siimple-table-cell {
  line-height: 34px;
  padding: 5px 0;
}

.siimple-table-cell,
.siimple-table-body .siimple-table-row:not(:last-child) .siimple-table-cell {
  border: 0;
}

@media (max-width: 480px) {
  .siimple-table-cell.answer {
    padding-bottom: 26px;
    padding-top: 0;
  }
  .siimple-table-cell {
    line-height: 24px;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SolutionItem.vue